import IBAN from 'iban';
import { ValidationRule } from 'vee-validate/dist/types/types';

const isIBAN: ValidationRule = {
  message: 'Der Wert ist keine valide IBAN',
  validate: (value?: string): boolean => !value || IBAN.isValid(value)
};

export default isIBAN;
